import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {CampaignService} from '../../campaign/service/campaign.service';
import {ReportService} from '../service/report.service';
import {EcareSecurityService} from '../../services/ecare_security_service';
import {first} from 'rxjs/operators';
import {ClientService} from '../../services/client.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-report-form',
  templateUrl: './report-form.component.html',
  styleUrls: ['./report-form.component.css']
})
export class ReportFormComponent implements OnInit {
  searchTerm: FormControl = new FormControl();
  date = new FormControl(new Date());
  campaignId: any;
  reportDetailsForm: FormGroup;
  campaignList: any ;
  leads: any ;
  reportFrequencyList: any ;
  loading: boolean;
  reportStatus = ''
  enableLeadsSelection = false;
  isValid = false;
  responseError = false;

  constructor(private campaignService: CampaignService, private _formBuilder: FormBuilder, private reportService: ReportService,
              private securityService: EcareSecurityService, private clientService: ClientService, private toastr: ToastrService) {
      this.isValid = false;
    this.reportDetailsForm = this._formBuilder.group({
      id: [''],
      reportFrequency: [''],
      prettyReportType: [''],
      selectedDate: [''],
        leads: [''],
        campaignId: [''],
      section47ReportType: [''],
      fullTraceReportType: ['']
    });
  }

  ngOnInit() {
    this.getReportFrequency();
    this.searchTerm.valueChanges.subscribe(
        term => {
          if (term !== '') {
            this.campaignService.getAllCampaigns(undefined,undefined, localStorage.getItem('clientId'), 0, 9999, term).subscribe(
                data => {
                  const response = data.json();
                  this.campaignList = response.campaigns;
                });
          }
        });
  }

  getCampaign(event) {
      console.log(event);
      this.campaignId = '' ;
      this.campaignId = event;
      this.campaignService.getCampaignsDetails(event).subscribe(
          data => {
              const response = data.json();
              this.campaignList = response.campaigns;
              this.leads = [];
              if (response.deviceSignalConfig[0].deviceSignalGroup === 'ECG_LEAD_VI') {
                  this.leads = ['ECG_I', 'ECG_II'];
              }
              if (response.deviceSignalConfig[0].deviceSignalGroup === 'ECG_LEAD_XII') {
                  this.leads = ['ECG_I', 'ECG_II', 'ECG_V1', 'ECG_V2', 'ECG_V3', 'ECG_V4', 'ECG_V5', 'ECG_V6'];
              }
          });
  }

  public getReportFrequency() {
    this.reportFrequencyList = [{
      id : 'HOURLY',
      name: 'HOURLY'
    },
      {
        id : 'DAILY',
        name: 'DAILY'
      },
      {
        id : 'WEEKLY',
        name: 'WEEKLY'
      }];
  }

  generateReport(reportDetailsForm) {
      if ((this.reportDetailsForm.controls['prettyReportType'].value === true || this.reportDetailsForm.controls['section47ReportType'].value === true
          || this.reportDetailsForm.controls['fullTraceReportType'].value === true) && this.reportDetailsForm.controls['reportFrequency'].value !== ''
      && this.reportDetailsForm.controls['selectedDate'].value !== '' && this.reportDetailsForm.controls['selectedDate'].value !== '') {
          console.log(reportDetailsForm.value['leads'])
          console.log(this.enableLeadsSelection)
          console.log('---------------')
          if (this.enableLeadsSelection && reportDetailsForm.value['leads'] !== '') {
              this.isValid = true;
          } else if (!this.enableLeadsSelection) {
              this.isValid = true;
          }
      }
    if (!this.isValid) {
        this.toastr.error('', 'Please fill all the fields and try again');
    } else {
        this.loading = true;
        console.log(reportDetailsForm);
        if (this.campaignId !== '') {
            this.reportDetailsForm.controls['campaignId'].setValue(this.campaignId);
        }

        let selectedDate = this.reportDetailsForm.controls['selectedDate'].value;

        let user = this.securityService.getUserDetails();
        let payload = reportDetailsForm.value;
        payload['reportFrequency'] = this.reportDetailsForm.controls['reportFrequency'].value;
        payload['prettyReportType'] = this.reportDetailsForm.controls['prettyReportType'].value;
        payload['section47ReportType'] = this.reportDetailsForm.controls['section47ReportType'].value;
        payload['fullTraceReportType'] = this.reportDetailsForm.controls['fullTraceReportType'].value;
        // payload['leads'] = this.reportDetailsForm.controls['multi-select'].value;
        let client = this.clientService.getClientByClientId(localStorage.getItem('clientId')).subscribe(response => {
            payload['userId'] = user.id;
            payload['firstName'] = user.firstName
            payload['email'] = user.email;
            payload['epoch_start'] = selectedDate.getTime();
            payload['hospitalName'] = response.clientName;
            this.reportService.generateReport(payload)
                .pipe(first())
                .subscribe(data => {
                    if (data.status === 200) {
                        this.reportStatus = 'Report generated successfully.';
                        console.log('Report generated successfully.');
                    } else {
                        this.reportStatus = 'Report could not be generated!';
                        this.responseError = true;
                    }
                    this.loading = false;
                }, (error) => {
                    this.reportStatus = 'Report could not be generated!';
                    this.loading = false;
                    this.responseError = true;
                });
        });
    }
  }

    changeLeadSelection() {
        const section47ReportType = this.reportDetailsForm.controls['section47ReportType'].value;
        const fullTraceReportType = this.reportDetailsForm.controls['fullTraceReportType'].value;

        if (section47ReportType || fullTraceReportType) {
            this.enableLeadsSelection = true;
        } else {
            this.enableLeadsSelection = false;
        }
    }
}
